var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2149_19202)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1461 0.843262L18.6527 4.3099C19.1157 4.76758 19.1157 5.51595 18.6527 5.97363L16.7133 7.89095L11.5238 2.76058L13.4632 0.843262C13.9262 0.385579 14.6832 0.385579 15.1461 0.843262ZM10.9764 8.56974V8.57129C11.1203 8.71354 11.1922 8.90218 11.1922 9.08773C11.1922 9.27327 11.1203 9.46037 10.9764 9.60417V9.60571L10.9748 9.60726L6.2702 14.2598H6.26864C6.22797 14.3 6.18261 14.3341 6.13726 14.3634H6.13569C6.08877 14.3928 6.04029 14.416 5.99024 14.433C5.7306 14.5227 5.42874 14.4639 5.22229 14.2598H5.22073V14.2583C5.18006 14.2181 5.14565 14.1733 5.11594 14.1284V14.1269C5.08622 14.0805 5.06276 14.0326 5.04555 13.9831C4.95484 13.7264 5.01427 13.428 5.21916 13.2239V13.2223L9.92537 8.56974H9.92693C10.0708 8.42749 10.2616 8.35636 10.4493 8.35636C10.637 8.35636 10.8263 8.42749 10.9717 8.56974H10.9764ZM7.11322 17.3708C5.70871 17.8007 4.30576 18.229 2.90125 18.6589C-0.398882 19.6685 -0.384805 20.3411 0.516084 17.1992L1.93467 12.2513L1.92998 12.2467L10.5416 3.73161L15.7311 8.86198L7.11791 17.377L7.11322 17.3708ZM2.81992 13.1265L6.22797 16.4957C5.30518 16.7771 4.3824 17.0585 3.46118 17.3384C1.29341 17.9986 1.3028 18.4408 1.89244 16.3766L2.81992 13.1265Z",
    fill: "#D17A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2149_19202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draftIcon.44894f5723647b41fd7a3d1c494e2a0d.svg";
export { ForwardRef as ReactComponent };